import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { Routes } from '@/features/routes'

const ZodRoutesSearch = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),

  currency: z
    .array(z.enum(['EUR', 'RON', 'USD']))
    .optional()
    .catch([]),
  accepts_stops: z
    .array(z.enum(['true', 'false']))
    .optional()
    .catch([]),
  sort_by: z
    .enum(['available_from', 'available_to', 'price_per_km', 'created_at'])
    .optional()
    .catch(undefined),
  sort_dir: z.enum(['asc', 'desc']).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/routes/')({
  validateSearch: ZodRoutesSearch,
  component: Routes,
})
